module.exports = __webpack_public_path__ + "img/ep-U-dosis.e8d05f7b.jpg";